<template>
  <select
    v-model="selectedSection"
    @change="setSelectedSection($event.target.value)"
    class="c-select c-select--center"
  >
    <option
      :class="{
        'is-active' :selectedSection === 'all',
      }"
      value="all"
      class="c-select__option"
    >
      Oversikt
    </option>
    <option
      v-for="section in sections"
      :key="section.id"
      :value="section.id"
      :class="{
        'is-active' : section.id === selectedSection,
      }"
      class="c-select__option"
    >
      {{ section.name }} – {{ section.availability.name }}
    </option>
  </select>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

import Section from '@/models/Section';
import Illustration from '@/models/Illustration';
import Selector from '@/models/Selector';

export default {
  name: 'SelectSections',
  data() {
    return {
      hasFocus: false,
    };
  },
  computed: {
    selector() {
      return Selector.query()
        .with('sections')
        .first();
    },
    sections() {
      return Section.query()
        .whereId(this.selector.section_ids)
        .with('availability')
        .get();
    },
    selectedSection:  {
      get: function() {
        return this.$store.state.entities.sections.selectedSection;
      },
      set: function(newValue) {
        let url;
        let id;
        if (newValue === 'all') {
          id = 'all';
        } else {
          const section = Section.query()
            .whereId(newValue)
            .first();
          url = section.url;
          id = section.id;
        }
        if (url) {
          window.location.href = url;
        } else {
          Section.commit(state => {
            state.selectedSection = id;
          });
          Illustration.commit(state => {
            state.currentSection = id;
          });
        }
      },
    },
    activeSection() {
      if (this.selectedSection !== 'all') {
        return Section.query()
          .whereId(this.selectedSection)
          .first();
      } else {
        return 'false';
      }
    },
  },
  watch: {
    selectedSection() {
      this.registerEvent(this.selectedSection);
    },
  },
  created() {
    EventBus.$on('section-focus', focus => {
      if (focus.hasFocus === true) {
        this.hasFocus = focus.id;
      } else {
        this.hasFocus = false;
      }
    });
  },
  methods: {
    updateSelectedSection(selectedSection) {
      Section.commit(state => {
        state.selectedSection = selectedSection;
      });
    },
    setSelectedSection(selectedSection) {
      localStorage.setItem('selectedSection', selectedSection);
    },
    toggleSectionFocus(focus) {
      EventBus.$emit('section-focus', {
        hasFocus: focus.hasFocus,
        id: focus.id,
      });
    },
    registerEvent(event) {
      let section = '';
      if (event === 'all') {
        section = 'alle';
      } else {
        section = this.activeSection.name;
      }
      this.$gtag.event(`Vis ${section} (bygg)`, {
        event_category: 'Filter',
        event_label: event,
      });
    },
  },
};
</script>